import React, { useEffect } from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "./components/Home/Home.css";
import { useState } from "react";
import { Route, Routes, useNavigate, BrowserRouter } from "react-router-dom";
import { Cookies } from "react-cookie";
import LoginPage from "./components/Login/Login";
import Home from "./components/Home/Home";
import { getInfoData } from "./network/api/loginapi";

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

function AppWrapper() {
  const navigate = useNavigate();
  const cookie = new Cookies();

  const [isLogin, setIsLogin] = useState(cookie.get("crm"));

  useEffect(() => {
    if (!isLogin) {
      navigate("/login");
    } else {
      getInfoData();
    }
  }, [isLogin]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage setIsLogin={setIsLogin} />} />
      <Route
        path="/"
        element={
          <Home role={cookie.get("role")} isSuper={cookie.get("super")} />
        }
      />
    </Routes>
  );
}

export default App;

export const list = [
  { id: 1, name: "yousskef", phone: "01022222222" },
  { id: 2, name: "Momhamed", phone: "0165600000" },
  { id: 3, name: "youssef", phone: "01022222222" },
  { id: 4, name: "Momhamed", phone: "01000000000" },
  { id: 5, name: "youssef", phone: "01022222222" },
  { id: 6, name: "Momhamed", phone: "01005900" },
];
